/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {FieldTextModule as ɵa} from './lib/field-text';